import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.lpsysadmin.widget.fund.member');
import { OnInit, Input } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-lpsysadmin-widget-fund-member',
template: templateSource || '',
    styles: [`

/* file: /opt/app/project/main/build/src/app/portal.lpsysadmin.widget.fund.member/view.scss */
:host {
  display: block;
  height: 100%;
}

table td,
table th {
  vertical-align: baseline;
}

.form-control {
  border-radius: 4px;
}

.btn-opt {
  margin: 4px;
  border-radius: 30px;
  height: auto;
  font: normal normal normal 16px Montserrat;
  padding: 12px 30px;
  border: 1px solid #72787F;
}
.btn-opt:hover {
  color: #FF5933;
  border: 1px solid #FF5933;
  background-color: #FFF2ED;
}
.btn-opt.active {
  background-color: #FF5933;
  color: #FFF;
  border: 1px solid #FF5933;
}`],
})
export class PortalLpsysadminWidgetFundMemberComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    @Input() fund: any;

    public members: any = [];
    public investments: any = [];
    public selected: any = null;
    public summary: any = {};

    public target_user: any = null;
    public show_send_message: any = null;
    public checked_user_id: any = [];

    public sortField: string = 'joined_at';
    public sortOrder: string = 'DESC';

    public userEvent: any = {
        close: async () => {
            this.target_user = null;
            this.show_send_message = null;
            this.checked_user_id = [];
            await this.load();
            await this.service.render();
        },
        updated: async () => {
            await this.load();
        }
    }

    public roleMap: any = {
        gp: 'GP',
        user: '조합원',
        staff: '담당자'
    }

    public async clickUser(user) {
        this.target_user = null;
        await this.service.render();
        this.target_user = user.id;
        await this.service.render();
    }

    public async ngOnInit() {
        await this.service.init();
        await this.load();
    }

    public async load() {
        const { data } = await wiz.call("list", { id: this.fund.id });
        const invRes = await wiz.call("investments", { id: this.fund.id });
        this.investments = invRes.data || [];

        for (let i = 0; i < data.length; i++) {
            if (!data[i].extra) data[i].extra = {};
            if (!data[i].extra.cert) data[i].extra.cert = [];
            if (!data[i].extra.income_doc) data[i].extra.income_doc = [];
            if (!data[i].extra.deduction) data[i].extra.deduction = {};
            for (let inv of this.investments) {
                if (!data[i].extra.deduction[inv.id]) {
                    data[i].extra.deduction[inv.id] = {};
                }
                if (!data[i].extra.deduction[inv.id].docs) {
                    data[i].extra.deduction[inv.id].docs = [];
                }
            }
            data[i]._originalNo = data.length - i;
        }
        this.members = data;
        this.summary = this.sum();
        await this.service.render();
    }

    public get sortedMembers() {
        if (!this.members || this.members.length === 0) return [];

        return [...this.members].sort((a, b) => {
            let valA: any, valB: any;

            if (this.sortField === 'joined_at') {
                valA = a.joined_at || '';
                valB = b.joined_at || '';
            } else if (this.sortField === 'name') {
                valA = a.user?.name || '';
                valB = b.user?.name || '';
                const cmp = valA.localeCompare(valB, 'ko');
                return this.sortOrder === 'ASC' ? cmp : -cmp;
            } else if (this.sortField === 'applied_amount') {
                valA = a.applied_amount || 0;
                valB = b.applied_amount || 0;
            }

            if (valA < valB) return this.sortOrder === 'ASC' ? -1 : 1;
            if (valA > valB) return this.sortOrder === 'ASC' ? 1 : -1;
            return 0;
        });
    }

    public async toggleSort(field: string) {
        if (this.sortField === field) {
            this.sortOrder = this.sortOrder === 'ASC' ? 'DESC' : 'ASC';
        } else {
            this.sortField = field;
            this.sortOrder = field === 'name' ? 'ASC' : 'DESC';
        }
        await this.service.render();
    }

    public sortIcon(field: string): string {
        if (this.sortField !== field) return ' ↕';
        return this.sortOrder === 'ASC' ? ' ▲' : ' ▼';
    }

    public memberBirth(item: any): string {
        const value = item?.birth || item?.user?.birth || item?.user?.extra?.birth || item?.user?.extra?.birth_date || '';
        const text = String(value || '').trim();
        if (!text) return '-';
        const digits = text.replace(/[^0-9]/g, '');
        if (/^\d{4}-\d{2}-\d{2}$/.test(text)) return text;
        if (digits.length === 8) return `${digits.slice(0, 4)}-${digits.slice(4, 6)}-${digits.slice(6, 8)}`;
        if (digits.length === 6) return digits;
        return text;
    }

    public interestAlerts(item: any): string[] {
        return Array.isArray(item?.interest_alerts) ? item.interest_alerts : [];
    }

    public isCorporateMember(item: any): boolean {
        return !!item?.is_corporate_lp || item?.lp_type === '법인' || item?.user?.extra?.lp_type === '법인';
    }

    public applicantName(item: any): string {
        return item?.display_name || item?.user?.name || item?.email || '';
    }

    public applicantManager(item: any): string {
        return item?.corporate_manager || item?.extra?.corporate_manager_name || item?.user?.extra?.corporate_manager_name || '';
    }

    public managerChecked(item: any, candidate: any): boolean {
        const managers = Array.isArray(item?.extra?.corporate_managers) ? item.extra.corporate_managers : [];
        return managers.some((manager: any) => {
            if (candidate.user_id && (manager.user_id === candidate.user_id || manager.id === candidate.user_id)) return true;
            if (candidate.email && String(manager.email || '').toLowerCase() === String(candidate.email || '').toLowerCase()) return true;
            return false;
        });
    }

    public async toggleCorporateManager(item: any, candidate: any, event: any) {
        if (!item.extra) item.extra = {};
        if (!Array.isArray(item.extra.corporate_managers)) item.extra.corporate_managers = [];
        if (event.target.checked) {
            if (!this.managerChecked(item, candidate)) {
                item.extra.corporate_managers.push({
                    user_id: candidate.user_id || candidate.id,
                    id: candidate.user_id || candidate.id,
                    name: candidate.name,
                    email: candidate.email,
                    company: candidate.company,
                    title: candidate.title
                });
            }
        } else {
            item.extra.corporate_managers = item.extra.corporate_managers.filter((manager: any) => {
                if (candidate.user_id && (manager.user_id === candidate.user_id || manager.id === candidate.user_id)) return false;
                if (candidate.email && String(manager.email || '').toLowerCase() === String(candidate.email || '').toLowerCase()) return false;
                return true;
            });
        }
        await this.service.render();
    }

    public corporateManagerNames(item: any): string {
        const managers = Array.isArray(item?.extra?.corporate_managers) ? item.extra.corporate_managers : [];
        const names = managers.map((manager: any) => manager.name || manager.email).filter((name: any) => !!name);
        return names.length > 0 ? names.join(', ') : '-';
    }

    public async update() {
        const { code } = await wiz.call("update", { id: this.fund.id, data: JSON.stringify(this.members) });
        if (code == 200)
            await this.service.alert.success("저장되었습니다.");
        else
            await this.service.alert.error("오류가 발생했습니다.");
        await this.service.render();
    }

    public async remove(item) {
        if (item.id) {
            let res = await this.alert(`조합원 '${item.user.name}'을 정말로 삭제하시겠습니까?`, '삭제', '취소');
            if (!res) return;

            const { code } = await wiz.call("remove", { id: this.fund.id, data: JSON.stringify(item) });

            if (code != 200) {
                await this.alert(`오류가 발생했습니다.`);
                return
            }
        }

        await this.load();
    }

    public sum() {
        let members = this.members;
        let result = 0;
        let budget = 0;
        let paid = 0;
        let recovered = 0;

        for (let i = 0; i < members.length; i++) {
            let member = members[i];
            if (['참여', '해산'].includes(member.status)) {
                result += member.applied_amount;
                budget += this.contributionAmount(member);
                paid += this.paidAmount(member);
                recovered += this.recoveredAmount(member);
            }
        }

        return {
            result,
            budget: this.service.formatter.currency(budget),
            paid: this.service.formatter.currency(paid),
            recovered: this.service.formatter.currency(recovered)
        };
    }

    public toNumber(value) {
        if (value === null || value === undefined || value === '') return 0;
        return Number(String(value).replace(/,/g, '')) || 0;
    }

    public contributionAmount(item) {
        return this.toNumber(item?.applied_amount) * this.toNumber(this.fund?.amount_per_share);
    }

    public paidAmount(item) {
        const saved = this.toNumber(item?.joined_budget || item?.extra?.contribution_paid || item?.extra?.paid_amount);
        if (saved > 0) return saved;
        return Math.floor(this.contributionAmount(item) * this.toNumber(this.fund?.extra?.finished_amount_rate) / 100);
    }

    public recoveredAmount(item) {
        const sell = item?.extra?.sell || {};
        let total = 0;
        for (let investmentId in sell) {
            const rows = Array.isArray(sell[investmentId]) ? sell[investmentId] : [];
            for (let row of rows) total += this.toNumber(row?.amount);
        }
        return total;
    }

    public async alert(message: string, action: string = '확인', cancel: any = false, status: string = 'error') {
        return await this.service.alert.show({
            title: "",
            message: message,
            cancel: cancel,
            actionBtn: status,
            action: action,
            status: status
        });
    }

    public mode: string = 'view';

    public async toggle(status) {
        this.mode = status;
        await this.load();
        await this.service.render();
    }

    public isEditable() {
        if (this.fund.investment_status == '결성') return true;
        if (this.mode == 'edit') return true;
        return false;
    }

    public async upload(item, target) {
        let files = await this.service.file.select();
        if (files.length == 0) return;

        await this.service.loading.show();
        for (let i = 0; i < files.length; i++) {
            let fd = new FormData();
            fd.append('upload', files[i]);
            let fdurl = '/file/upload?mode=fund.member-' + item.fund_id + "-" + item.user.id;
            const { url } = await this.service.file.upload(fdurl, fd, async (percent: number, total: number, position: number) => { });
            item.extra[target].push({ name: files[i].name, url: url });
        }
        await this.service.loading.hide();

        await this.update();
        this.service.render();
    }

    public async uploadInvestDoc(item, investId) {
        let inv = this.investments.find(i => i.id === investId);

        // 기본 소득공제 년도 결정 — 연도 입력은 더 이상 다이얼로그로 묻지 않음.
        // 우선순위: 해당 조합원의 year_override → 펀드 내 다른 조합원의 year_override(최빈) → 결성일 → 현재 연도
        // 개별 연도 조정이 필요하면 [시기변경] 버튼을 이용.
        let yearStr = '';
        if (item.extra?.deduction?.[investId]?.year_override) {
            yearStr = String(item.extra.deduction[investId].year_override);
        } else {
            const fundWideYear = this.findFundWideYearOverride(investId);
            if (fundWideYear) {
                yearStr = fundWideYear;
            } else if (this.fund?.registered_date) {
                yearStr = String(this.fund.registered_date).substring(0, 4);
            } else {
                yearStr = String(new Date().getFullYear());
            }
        }

        let files = await this.service.file.select();
        if (files.length == 0) return;

        if (!item.extra.deduction) item.extra.deduction = {};
        if (!item.extra.deduction[investId]) item.extra.deduction[investId] = {};
        if (!item.extra.deduction[investId].docs) item.extra.deduction[investId].docs = [];

        // 동일 펀드 조합원에게 기본 year_override 전파 (개별 설정 보존)
        item.extra.deduction[investId].year_override = yearStr;
        this.propagateYearOverride(investId, yearStr);

        await this.service.loading.show();
        for (let i = 0; i < files.length; i++) {
            let fd = new FormData();
            fd.append('upload', files[i]);
            let fdurl = '/file/upload?mode=fund.member-' + item.fund_id + "-" + item.user.id;
            const { url } = await this.service.file.upload(fdurl, fd, async (percent: number, total: number, position: number) => { });
            item.extra.deduction[investId].docs.push({ name: files[i].name, url: url, year: yearStr });
        }
        await this.service.loading.hide();

        await this.update();
        await this.service.render();
    }

    /**
     * 개별 조합원의 특정 기업(investId)에 대해 소득공제 연도(year_override)만 변경.
     * 기존 서류의 year 메타도 같이 갱신한다. 다른 조합원에게는 전파하지 않는다.
     */
    public async changeInvestYear(item, investId) {
        const inv = this.investments.find(i => i.id === investId);
        const companyName = inv?.company_name || '해당 기업';
        const memberName = item?.user?.name || '조합원';

        let currentYear = '';
        if (item.extra?.deduction?.[investId]?.year_override) {
            currentYear = String(item.extra.deduction[investId].year_override);
        } else {
            const fundWideYear = this.findFundWideYearOverride(investId);
            if (fundWideYear) {
                currentYear = fundWideYear;
            } else if (this.fund?.registered_date) {
                currentYear = String(this.fund.registered_date).substring(0, 4);
            } else {
                currentYear = String(new Date().getFullYear());
            }
        }

        let yearStr = window.prompt(
            `[시기변경]\n조합원: ${memberName}\n기업: ${companyName}\n\n소득공제 년도를 입력하세요 (4자리, 예: ${currentYear})`,
            currentYear
        );
        if (yearStr === null) return;
        yearStr = yearStr.trim();
        if (!/^\d{4}$/.test(yearStr)) {
            await this.service.alert.error("4자리 연도(YYYY)를 입력하세요.");
            return;
        }

        if (!item.extra) item.extra = {};
        if (!item.extra.deduction) item.extra.deduction = {};
        if (!item.extra.deduction[investId]) item.extra.deduction[investId] = {};
        if (!item.extra.deduction[investId].docs) item.extra.deduction[investId].docs = [];

        item.extra.deduction[investId].year_override = yearStr;
        // 해당 조합원의 기존 서류 year 메타도 같이 갱신
        for (const f of item.extra.deduction[investId].docs) {
            f.year = yearStr;
        }

        await this.update();
        await this.service.render();
    }

    /**
     * 펀드 내 모든 조합원에서 해당 investId에 설정된 year_override를 찾는다.
     * 가장 흔한 값(최빈)을 fund-wide 기본값으로 간주.
     */
    private findFundWideYearOverride(investId: any): string {
        if (!this.members || this.members.length === 0) return '';
        const counts: { [year: string]: number } = {};
        for (const m of this.members) {
            const y = m?.extra?.deduction?.[investId]?.year_override;
            if (y) {
                const key = String(y);
                counts[key] = (counts[key] || 0) + 1;
            }
        }
        let bestYear = '';
        let bestCount = 0;
        for (const y in counts) {
            if (counts[y] > bestCount) {
                bestCount = counts[y];
                bestYear = y;
            }
        }
        return bestYear;
    }

    /**
     * 펀드 내 모든 조합원의 해당 investId에 year_override 값을 전파.
     * 개별 시기변경값(다른 연도)이 이미 명시적으로 설정된 경우는 덮어쓰지 않는다.
     * (단, 빈 값이거나 새로 설정하는 케이스에는 적용)
     */
    private propagateYearOverride(investId: any, yearStr: string) {
        if (!this.members) return;
        for (const m of this.members) {
            if (!m.extra) m.extra = {};
            if (!m.extra.deduction) m.extra.deduction = {};
            if (!m.extra.deduction[investId]) m.extra.deduction[investId] = {};
            const cur = m.extra.deduction[investId].year_override;
            if (!cur) {
                m.extra.deduction[investId].year_override = yearStr;
            }
        }
    }

    public deductionLabel(item: any, inv: any, file: any = null): string {
        let year = '';
        if (file?.year) {
            year = String(file.year);
        } else if (item.extra?.deduction?.[inv.id]?.year_override) {
            year = String(item.extra.deduction[inv.id].year_override);
        } else if (inv?.investment_date) {
            year = String(inv.investment_date).substring(0, 4);
        } else if (this.fund?.registered_date) {
            year = String(this.fund.registered_date).substring(0, 4);
        }
        let companyName = inv?.company_name || '-';
        let memberName = item?.user?.name || '-';
        let fundName = this.fund?.name || '-';
        let yearLabel = year ? `${year}년` : '-';
        return `${companyName} · ${yearLabel} · ${memberName} · ${fundName}`;
    }

    public async clearInvestDoc(item, investId, file) {
        item.extra.deduction[investId].docs.remove(file);
        await this.service.render();
        await this.update();
    }

    public async clearValue(obj, key) {
        obj.remove(key)
        await this.service.render();
        await this.update();
    }

    public async onChangeAll(event) {
        const items = Array.from(document.querySelectorAll('input.check-user'));

        items.forEach(i => {
            if (event.target.checked) {
                if (!i.checked) {
                    i.click()
                }
            } else {
                if (i.checked) {
                    i.click()
                }
            }
        });
    }

    public async onChangeUser(user_id, event) {
        if (event.target.checked) {
            this.checked_user_id.push(user_id);
        } else {
            this.checked_user_id = this.checked_user_id.filter((item) => item !== user_id);
        }
    }

    public async onClickSendMessage() {
        this.show_send_message = true;
        await this.service.render();
    }
}

export default PortalLpsysadminWidgetFundMemberComponent;